module.exports = __webpack_public_path__ + "static/media/electrical-2476782_960_720.941cdcee.jpg";